module.exports = __webpack_public_path__ + "static/hero-d43843096948c298b7581feb0b6d7843.png";